import React from 'react'

import { ListGrid, HeadingMedium, CTALink, ArrowRightIcon, Button } from '@pb/components'
import { getLocale } from '@pb/utils'
import { useSelector } from 'react-redux'

import appSelectors from 'App/duck/selectors'
import Loader from 'features/favourites/components/Stylehub/components/Following/components/Loader'
import StyleboardItem from 'features/favourites/components/Stylehub/components/Following/components/StyleboardItem'
import classes from 'features/favourites/components/Stylehub/components/Following/Following.module.scss'
import {
  popularStyleboardsHeading,
  popularStyleboardsViewAll,
  popularStyleboardsExplore,
} from 'features/favourites/components/Stylehub/components/Following/labels'
import { trackClickOnViewAllPublicStyleboards } from 'features/favourites/tracking'
import { PopularStyleboardsProps } from 'features/Styleboard/types'

const PopularStyleboards: React.FC<PopularStyleboardsProps> = ({ styleboards, onQuickFollow }) => {
  const isSmallScreen = useSelector(appSelectors.getIsSmallScreen)

  if (!styleboards) return <Loader />

  const headingNodeMobile = (
    <HeadingMedium Tag="h2" className={classes.popularStyleboardsHeading}>
      {popularStyleboardsHeading}
    </HeadingMedium>
  )

  const headingNodeDesktop = (
    <div className={classes.popularStyleboardsHeadingContainer}>
      {headingNodeMobile}
      <CTALink
        href="/styleboard"
        onClick={() => trackClickOnViewAllPublicStyleboards()}
        iconPosition="end"
        iconElement={<ArrowRightIcon />}
      >
        {popularStyleboardsViewAll}
      </CTALink>
    </div>
  )

  return (
    <>
      {isSmallScreen ? headingNodeMobile : headingNodeDesktop}
      <div className={classes.popularStyleboardsGridContainer}>
        <ListGrid
          numberOfColumns={{
            xsmall: 1,
            small: 1,
            medium: 1,
            large: 2,
            xlarge: 3,
            xxl: 3,
          }}
          gridGap="large"
          className={classes.styleboardsContainer}
          shouldHaveItemFlex={false}
        >
          {styleboards.map((styleboard) => (
            <StyleboardItem
              styleboard={styleboard}
              shouldShowCheckbox
              onQuickFollow={onQuickFollow}
              key={styleboard.id}
            />
          ))}
        </ListGrid>
        {isSmallScreen && (
          <div className={classes.popularStyleboardsLinkContainer}>
            <Button
              href={`/${getLocale()}/styleboard`}
              Tag="a"
              iconElement={<ArrowRightIcon className={classes.arrowIcon} />}
              iconPosition="end"
              onClick={() => trackClickOnViewAllPublicStyleboards()}
            >
              {popularStyleboardsExplore}
            </Button>
          </div>
        )}
      </div>
    </>
  )
}

export default PopularStyleboards
